/* Recently viewed. Spec: docs/04 §JS/APIs "Recently viewed". Records the
   current product handle on any /products/{handle} view (no template.name
   dependency, so this works no matter which PDP section owns the page) and
   renders the list wherever sections/recently-viewed.liquid mounts, via the
   `?view=card` alternate template + snippets/card-product.liquid. */
(() => {
  const KEY = 'ag_recent';
  const MAX = 12;

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage blocked */ }
  };

  const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
  if (match) {
    const handle = match[1];
    const list = read().filter((h) => h !== handle);
    list.unshift(handle);
    write(list.slice(0, MAX));
  }

  const mount = document.querySelector('[data-ag-recent-mount]');
  if (!mount) return;
  const selfHandle = match ? match[1] : null;
  const handles = read().filter((h) => h !== selfHandle).slice(0, Number(mount.dataset.agRecentLimit) || 8);
  if (!handles.length) { mount.closest('[data-ag-recent-section]')?.setAttribute('hidden', ''); return; }

  Promise.all(
    handles.map((h) =>
      fetch(`/products/${h}?view=card`)
        .then((r) => (r.ok ? r.text() : ''))
        .catch(() => '')
    )
  ).then((cards) => {
    const html = cards.filter(Boolean).join('');
    if (!html) { mount.closest('[data-ag-recent-section]')?.setAttribute('hidden', ''); return; }
    mount.innerHTML = html;
  });
})();
